import { IProductDetailPayment } from "../../@types/IProduct/IProductDetail";
import React, { useContext, useEffect, useState } from "react";
import { Checkbox, Popconfirm } from "antd";
import { DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import RoundColor from "./RoundColor";
import RoundSize from "./RoundSize";
import InputNumber from "../Input/InputNumber";
import { IProductAccessoryPayment } from "../../@types/IProduct/IProductAccessory";
import environment from "../../utils/environment";
import { currencyFormatter } from "../../utils/format";
import moment from "moment/moment";
import { checkItem, errorAmount, handleChangeQty, totalProduct } from "./util";
import PaymentContext from "../../store/PaymentContext";
import { IAdditionalInformation, ICustomerAppContext } from "../../@types/IContext/IPaymentContext";
import { event } from "nextjs-google-analytics";
import { PaymentConst, mapToGtag } from "../../utils/payment";
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { refreshStocking } from "./TableProduct";
import toast from "react-hot-toast";
const { RangePicker } = DatePicker;

interface IProps {
    products: IProductDetailPayment[] | IProductAccessoryPayment[] | any,
    is_accessory: boolean,
    is_purchase: boolean,
    parent_item: IProductDetailPayment | null | any,
    carts: IProductDetailPayment[],
    setCarts: Function | any,
    additionalInformation: IAdditionalInformation,
    baseCustomer: ICustomerAppContext,
    className: string,
}

const Column = ({ children, className, ...props }: any) => {
    return (
        <div className={`cart_table-column ${className}`} {...props}>
            {children}
        </div>
    )
}

const TableGroup: React.FC<IProps> = ({
    parent_item,
    is_purchase,
    products,
    is_accessory,
    carts,
    setCarts,
    additionalInformation,
    baseCustomer,
    className
}) => {
    //console.log("products", products);
    const { isMobile, handleCalculateFee, currentStep, customer, setModalCustomer, tabActiveStep1, sellCarts, rentCarts, setSpinLoading } = useContext(PaymentContext);
    let isPurchase = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? false : true;

    const [toggle, setToggle] = useState(false);
    let linkImg = "/asset/image/no_product.jpg";

    //let isChecked = products?.filter((e: any) => !e.bundling_id).length > 0 ? products?.filter((e: any) => !e.bundling_id).every((product: IProductAccessoryPayment | IProductDetailPayment | any) => product.checked) : products?.every((product: IProductAccessoryPayment | IProductDetailPayment | any) => product.checked);
    //let hasAttach = products?.find((e: any) => e.bundling_id) && products.find((e: any) => !e.bundling_id) ? true : false;
    let isChecked = products?.filter((e: any) => !e.bundling_id).every((product: IProductAccessoryPayment | IProductDetailPayment | any) => product.checked);
    let hasAttach = products?.find((e: any) => e.bundling_id) ? true : false;
    //console.log("products.find((e: any) => !e.bundling_id)", products, products.find((e: any) => !e.bundling_id));
    //console.log('isChecked', isChecked);


    const updateCustomer = () => {

        if (currentStep == 1 && !customer.name) {
            setModalCustomer({
                open: true,
                type: 'customer'
            })
        }
    }

    const deleteContent = (item: IProductAccessoryPayment | IProductDetailPayment | any) => {
        return (
            <Popconfirm
                className="pop-confirm-custom"
                placement={isMobile ? "top" : "left"}
                title={"Xóa sản phẩm"}
                description={"Bạn có muốn xóa sản phẩm ra khỏi giỏ hàng?"}
                onConfirm={() => {
                    const parent_id: number | any = parent_item?.id;
                    if (parent_id > 0) {

                        let parentIndex = carts.findIndex((prod: any) => prod.id === parent_id);
                        //console.log("parent_item", parent_item, carts, parent_id);

                        if (parent_item?.take_date && parent_item?.return_date) {
                            parentIndex = carts.findIndex((prod: any) => prod.id === parent_id && prod.take_date === parent_item?.take_date && prod.return_date === parent_item?.return_date);
                            //console.log("parentIndex", carts, parentIndex);
                        }

                        if (carts[parentIndex]?.is_product == false && !item.bundling_id) {
                            //console.log("Inn carts[parentIndex] 1");

                            carts = carts.filter((acc: any) => acc.id !== parent_id)
                            //console.log("Inn carts[parentIndex] 1", carts.filter((acc: any) => acc.id !== parent_id));
                        } else if (carts[parentIndex]?.is_product == false && item.bundling_id) {
                            //console.log("Inn carts[parentIndex] 2");
                            carts[parentIndex].accessories = carts[parentIndex]?.accessories.filter((acc: any) => acc.id !== item.id);
                            carts[parentIndex].temp_accessories = carts[parentIndex]?.temp_accessories.filter((acc: any) => acc.id !== item.id);
                        }
                        //console.log("Inn 232", carts[parentIndex]);
                        if (parentIndex > -1 && carts[parentIndex]?.is_product == true) {
                            let accessories = carts[parentIndex].accessories;
                            let temp_accessories = carts[parentIndex].temp_accessories;
                            accessories = accessories.filter((acc: any) => acc.id !== item.id);
                            //****Tạm ẩn cho set lẻ
                            //temp_accessories = temp_accessories.filter((acc: any) => acc.id !== item.id);

                            if (item.bundling_id) {


                                carts[parentIndex].is_bundling = false;
                                accessories = accessories?.filter((e: any) => e.id !== item.id).map((e: any) => {
                                    e.is_bundling = false
                                    return e;
                                })
                                temp_accessories = temp_accessories?.filter((e: any) => e.id !== item.id).map((e: any) => {
                                    e.is_bundling = false
                                    return e;
                                })
                            }

                            carts[parentIndex].accessories = accessories;
                            carts[parentIndex].temp_accessories = temp_accessories;
                            //console.log("Inn 232", parentIndex, accessories);
                            if (accessories.length === 0 && !item.bundling_id && carts[parentIndex]?.is_product == false) {
                                carts.splice(parentIndex, 1);
                                //console.log("carts", carts);
                            }
                            if (accessories.length === 0 && carts[parentIndex].temp_accessories.filter((e: any) => !e.bundling_id).length > 0) {
                                carts.splice(parentIndex, 1);
                            }

                        }
                        //console.log("xóa 2", carts);
                        setCarts([...carts]);
                        //setCarts([...refreshStocking(isPurchase, carts, setCarts, setSpinLoading)])
                        event("remove_from_cart", mapToGtag([...carts], is_purchase));
                    } else {

                        let find: any = carts.find((pro: any) => pro.id === item.id && pro?.take_date === item?.take_date && pro?.return_date === item?.return_date) ?? []
                        let newCarts = [...carts.filter((pro: any) => {
                            if (pro.id === item.id) {
                                if (item?.take_date && item?.return_date) {
                                    return !(moment(pro?.take_date).format("DD/MM/YYYY") === moment(item?.take_date).format("DD/MM/YYYY") && moment(pro?.return_date).format("DD/MM/YYYY") === moment(item?.return_date).format("DD/MM/YYYY"))
                                }
                            }
                            return pro.id !== item.id
                        })]

                        // setCarts([...carts.filter((pro: any) => {
                        //     if (pro.id === item.id) {
                        //         if (item?.take_date && item?.return_date) {
                        //             return !(moment(pro?.take_date).format("DD/MM/YYYY") === moment(item?.take_date).format("DD/MM/YYYY") && moment(pro?.return_date).format("DD/MM/YYYY") === moment(item?.return_date).format("DD/MM/YYYY"))
                        //         }
                        //     }
                        //     return pro.id !== item.id
                        // })])
                        setCarts(newCarts);
                        //refreshStocking(isPurchase, newCarts, setCarts, setSpinLoading)
                        event("remove_from_cart", mapToGtag([find], is_purchase));
                    }
                }}
                okText="Xóa"
                cancelText="Hủy"
            >
                <Column className={`text-center ${isMobile ? 'pr-2 flex items-center' : 'cart_table_action w-16'} cursor-pointer`}>
                    {isMobile ? <DeleteOutlined className="color-danger" rev={undefined} /> : "Xóa"}
                </Column>
            </Popconfirm>
        )
    }

    const handleOnChecked = async (isChecked: boolean, item: IProductDetailPayment | IProductAccessoryPayment, orginItem: IProductDetailPayment | IProductAccessoryPayment) => {

        const result = checkItem(
            carts,
            Array.isArray(item) ? item : [item],
            isChecked,
            is_purchase,
            parent_item ? parent_item?.id : 0,
            parent_item?.take_date ?? undefined,
            parent_item?.return_date ?? undefined,
            orginItem
        )
        //let cloneCarts = await refreshStocking(isPurchase, result, setSpinLoading);
        updateCustomer();
        setCarts(result);
        //setCarts(cloneCarts);
        handleCalculateFee(result, is_purchase, baseCustomer, additionalInformation);
    }

    const onChangeQty = async (value: number, item: IProductDetailPayment | IProductAccessoryPayment | any, isAccessory: any = null) => {

        const result: any = handleChangeQty(
            carts,
            item,
            isAccessory !== null ? isAccessory : is_accessory,
            value, is_purchase,
            parent_item ? parent_item.id : 0
        );

        // if (!item?.bundling_id) {
        //     if (value > item.amount) {
        //         toast.error(`Sản phẩm ${item.name} vượt quá số lượng tồn kho là ${item.amount}`);
        //         return
        //     }
        // } else {
        //     if (value > item.maximum_order) {
        //         toast.error(`Sản phẩm ${item.name} vượt quá số lượng đơn đặt hàng là ${item.maximum_order}`)
        //         return
        //     }
        // }

        //console.log("result", result);

        //let cloneCarts = await refreshStocking(isPurchase, result, setSpinLoading);
        updateCustomer()
        setCarts(result);
        //setCarts(cloneCarts);
        handleCalculateFee(result, is_purchase, baseCustomer, additionalInformation);
        //console.log("Innn 6666");

    }

    const onChangeDate = async (value: any, item: IProductDetailPayment | IProductAccessoryPayment | any, isAccessory: any = null) => {
        let cloneCart = carts.find((e: IProductDetailPayment) => e.id === item.id);
        if (cloneCart) {
            cloneCart.checked = true
            cloneCart.take_date = value && value.length > 0 ? dayjs(value[0]).format("MM-DD-YYYY") : "";
            cloneCart.return_date = value && value.length > 0 ? dayjs(value[1]).format("MM-DD-YYYY") : "";
            cloneCart.accessories?.map((item: any) => {
                item.checked = true
                item.return_date = value && value.length > 0 ? dayjs(value[1]).format("MM-DD-YYYY") : "";
                item.take_date = value && value.length > 0 ? dayjs(value[0]).format("MM-DD-YYYY") : "";
            });
            carts = carts?.map((item: any) => {
                if (item.id === cloneCart?.id) {
                    item = cloneCart
                }
                return item
            })
        }

        updateCustomer();

        //let cloneCarts = await refreshStocking(isPurchase, carts, setSpinLoading);
        handleCalculateFee(carts, is_purchase, baseCustomer, additionalInformation);
        //console.log("Innn 6666");
        //setCarts(cloneCarts);
        setCarts(carts);

    }
    //console.log("parent_item", parent_item);
    //console.log("parent_item?.is_product === false ? (parent_item?.checked ?? false) : isChecked", parent_item?.is_product === false ? (parent_item?.checked ?? false) : hasAttach ? (parent_item?.checked ?? false) : isChecked);
    //console.log("isChecked", isChecked);
    //console.log("hasAttach", hasAttach);

    useEffect(() => {
        //refreshStocking(isPurchase, isPurchase ? sellCarts : rentCarts, setCarts)
    }, [products])

    return (
        <div className={`grid gap-4 ${isMobile ? 'mt-4' : 'mt-4'} ${className}`}>
            {
                isMobile ? (
                    <div className="flex bg-white h-12 items-center rounded shadow-xl">
                        <Column className={`flex items-center pl-2 w-full`}>
                            <span className="text-xl bold truncate max-w-[250px]">
                                <Checkbox
                                    key={parent_item?.id}
                                    className="cus-checkbox mr-2"
                                    checked={isChecked}
                                    onClick={() => {
                                        handleOnChecked(!isChecked, products, parent_item)
                                    }}
                                /> {parent_item ? parent_item.name : "Sản phẩm"}
                            </span>
                        </Column>
                        <Column
                            className="w-16 flex items-center justify-center cursor-pointer"
                            onClick={() => { setToggle(!toggle) }}
                        >
                            {toggle ? <DownOutlined rev={undefined} /> : <UpOutlined rev={undefined} />}
                        </Column>
                    </div>
                ) : (
                    <div className="flex bg-white py-3 items-center rounded shadow-xl ">
                        <Column className={`flex items-center pl-2 ${!is_purchase ? 'w-2/6' : 'w-3/6'}`}>
                            <span className="text-xl bold truncate-text-max-length">
                                <Checkbox
                                    //key={parent_item.id}
                                    className="cus-checkbox mr-2"
                                    checked={parent_item?.is_product === false ? (parent_item?.checked ?? false) : hasAttach ? (parent_item?.checked ?? false) : isChecked}
                                    //checked={parent_item?.checked}
                                    onClick={(e: any) => {
                                        // console.log("e", !(parent_item?.is_product === false ? (parent_item?.checked ?? false) : hasAttach ? (parent_item?.checked ?? false) : isChecked));

                                        handleOnChecked(!(parent_item?.is_product === false ? (parent_item?.checked ?? false) : hasAttach ? (parent_item?.checked ?? false) : isChecked), products, parent_item)
                                    }}
                                /> {parent_item ? parent_item.name : "Sản phẩm"}
                            </span>
                        </Column>
                        <Column className={` ${!is_purchase ? 'w-1/6' : 'w-4/12'} cart_table-column-item flex flex-col justify-center`}>

                            {
                                (parent_item?.is_product === false || parent_item?.is_bundling === true) ? <>
                                    <span>Giá thuê: {currencyFormatter.format(parent_item.rental_price)}</span>
                                    <span>Giá bán: {currencyFormatter.format(parent_item.price)}</span>
                                </> : <>Đơn giá</>
                            }
                        </Column>
                        {
                            !is_purchase && (
                                <Column className="relative w-1/6 text-center cart_table-column-item flex items-center justify-center gap-0.5 text-center">

                                    {
                                        //(parent_item?.is_product === false || parent_item?.is_bundling === true || parent_item?.is_set === true) 
                                        parent_item ? <div className="flex flex-col gap-2">
                                            <span>Thời gian thuê</span>
                                            {/* <div className="flex flex-col">
                                                <div className="underline">Từ: {parent_item.take_date ? moment(parent_item.take_date).format("DD-MM-YYYY") : null}</div>
                                                <div className="underline">Đến: {parent_item.return_date ? moment(parent_item.return_date).format("DD-MM-YYYY") : null}</div>
                                            </div>
                                            <img onClick={() => {
                                                setOnOpen(!onOpenDate)
                                            }} src="/asset/icon/ico_calender.svg" alt="icon" /> */}
                                            <RangePicker
                                                className=""
                                                disabledDate={(current) => {
                                                    return current && current < moment().startOf('day');
                                                }}
                                                placeholder={["Từ", "Đến"]}
                                                id={"range_" + parent_item?.id}
                                                onChange={(e: any) => {
                                                    onChangeDate(e, parent_item, true)
                                                }}
                                                format={'DD/MM/YYYY'}
                                            />
                                        </div> : <>Thời gian thuê</>

                                    }
                                </Column>
                            )
                        }
                        <Column className={`${!is_purchase ? 'w-1/6' : 'w-2/12'} text-center flex justify-center cart_table-column-item`}>
                            {
                                is_accessory ? (
                                    <InputNumber
                                        min={1}
                                        value={parent_item.qty}
                                        onChange={(value: any) => {
                                            onChangeQty(value, parent_item, false);
                                        }}
                                        //max={parent_item?.is_bundling ? parent_item.maximum_order : 99999}

                                        error={errorAmount(parent_item)}
                                        //max={parent_item.amount}
                                        disabled={false}
                                    />
                                ) : 'Số lượng'
                            }
                        </Column>
                        <Column className={`${!is_purchase ? 'w-1/6' : 'w-2/12'} text-right px-2 color-danger bold text-lg `}>
                            {/* {
                                is_accessory ? parent_item?.is_bundling === true ? currencyFormatter.format((parent_item.is_purchase ? parent_item.price : parent_item.rental_price) * (parent_item.qty ?? 0)) : currencyFormatter.format(totalProduct(parent_item, false)) : 'Tổng tiền'
                            } */}
                            {
                                is_accessory ? currencyFormatter.format((parent_item?.is_purchase ? parent_item?.price : parent_item?.rental_price) * (parent_item?.qty ?? 0)) : 'Tổng tiền'
                            }
                        </Column>
                        <Column
                            className="w-16 flex items-center justify-center cursor-pointer cart_table-column-item"
                            onClick={() => { setToggle(!toggle) }}
                        >
                            {toggle ? <DownOutlined rev={undefined} /> : <UpOutlined rev={undefined} />}
                        </Column>
                    </div>
                )
            }

            {
                products?.map((item: IProductAccessoryPayment | IProductDetailPayment | any, index: number) => {
                    let img_url = (item?.files?.length > 0 && item?.files[0]?.file_url ? item?.files[0]?.file_url : item?.file?.file_url);
                    if (img_url) {
                        linkImg = environment.baseImageUrl + img_url;
                    }

                    const price = is_purchase ? item.price : item.rental_price
                    let take_date = item.take_date ? moment(item.take_date).format("DD-MM-YYYY") : null;
                    let return_date = item.return_date ? moment(item.return_date).format("DD-MM-YYYY") : null;

                    if ((parent_item?.is_product === false || parent_item?.is_bundling === true)) {
                        take_date = parent_item.take_date ? moment(parent_item.take_date).format("DD-MM-YYYY") : null;
                        return_date = parent_item.return_date ? moment(parent_item.return_date).format("DD-MM-YYYY") : null;
                    }
                    //console.log("item", item);


                    return isMobile ? (
                        <div key={`${item.id}_${index}`} className={`flex bg-white items-center rounded-lg shadow-xl ${toggle ? 'hidden' : ''}`}>
                            <Column className={`w-full flex relative gap-2`}>
                                <div style={{ width: 90 }}>
                                    <img src={linkImg} alt="icon" className="rounded-tl-lg rounded-bl-lg w-full h-full object-cover	" />
                                </div>
                                <Checkbox
                                    key={item.id}
                                    className="cus-checkbox mr-2 absolute top-2 left-2"
                                    // checked={parent_item?.is_product === false ? parent_item.checked : item.checked}
                                    checked={parent_item?.is_product === false && !item.bundling_id ? parent_item.checked : item.checked}
                                    onClick={() => {
                                        handleOnChecked(!item.checked, item, item)
                                    }}
                                />
                                <div className={`flex flex-col ${item.is_purchase ? 'gap-2' : 'gap-0.5'} py-2 justify-center pr-2`} style={{ width: 'calc(100% - 116px)' }}>
                                    <div className="flex flex-row gap-3 items-center">
                                        <span className="bold truncate max-w-[180px]">
                                            {item.name}
                                        </span>
                                        <span className="bold truncate max-w-[180px]">
                                            {item.bundling_id ? "(SP bán kèm)" : ""}
                                        </span>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="flex gap-2">
                                            <RoundColor
                                                value={item.attribute_value_ids}
                                                lstValue={item.attribute_values}
                                            />
                                            <RoundSize
                                                value={item.attribute_value_ids}
                                                lstValue={item.attribute_values}
                                            />
                                        </div>

                                        <div className='product_detail_right--row flex justify-center pr-2'>
                                            <InputNumber
                                                min={1}
                                                value={item.qty}
                                                onChange={(value: any) => { onChangeQty(value, item) }}
                                                //max={item?.bundling_id ? (item.maximum_order ?? 99999) : 99999}
                                                error={errorAmount(item)}
                                                disabled={false}
                                            />
                                        </div>
                                    </div>

                                    {
                                        item.is_purchase ? null : (
                                            <div className="flex items-center gap-1">
                                                <span className="underline">{take_date} - {return_date}</span>
                                            </div>
                                        )
                                    }
                                    <div className="flex justify-between items-center">
                                        <div className="text-xs">
                                            <div className="flex">Thuê: {currencyFormatter.format(item.rental_price)}</div>
                                            <div className="flex">Bán: {currencyFormatter.format(item.price)}</div>
                                        </div>
                                        {
                                            deleteContent(item)
                                        }
                                    </div>
                                </div>
                            </Column>

                        </div>
                    ) : (
                        <div key={`${item.id}_${index}`} className={`flex bg-white items-center rounded-lg shadow-xl ${toggle ? 'hidden' : ''}`}>
                            <Column className={`${!is_purchase ? 'w-2/6' : 'w-3/6'}`}>
                                <div className="w-full flex items-center relative gap-2 overflow-hidden">
                                    <img src={linkImg} alt="icon" className="rounded-tl-lg rounded-bl-lg carts-image" />
                                    <Checkbox
                                        key={item.id}
                                        className="cus-checkbox mr-2 absolute top-2 left-2"
                                        checked={parent_item?.is_product === false && !item.bundling_id ? parent_item.checked : item.checked}
                                        onClick={() => {
                                            handleOnChecked(!item.checked, item, item)
                                        }}
                                    />
                                    <div className="flex flex-col gap-0.5">
                                        <div className={"flex flex-row gap-2 truncate-text-max-length  xl:w-[300px] " + (!is_purchase ? 'w-[150px]' : 'w-[200px]')}>
                                            <span className="bold ">
                                                {item.name}
                                            </span>
                                            <span className="bold truncate">
                                                {item.bundling_id ? "(SP bán kèm)" : ""}
                                            </span>
                                        </div>
                                        <RoundColor
                                            value={item.attribute_value_ids}
                                            lstValue={item.attribute_values}
                                        />
                                        <RoundSize
                                            value={item.attribute_value_ids}
                                            lstValue={item.attribute_values}
                                        />
                                    </div>
                                </div>
                            </Column>
                            <Column className={` ${!is_purchase ? 'w-1/6' : 'w-4/12'} flex flex-col justify-center`}>
                                <span>Giá thuê: {currencyFormatter.format(item.rental_price)}</span>
                                <span>Giá bán: {currencyFormatter.format(item.price)}</span>
                            </Column>
                            {
                                !is_purchase && (
                                    <Column className="w-1/6 flex items-center justify-center gap-0.5 text-center">
                                        {parent_item ? <>
                                            <div className="flex flex-col">
                                                <div className="underline">Từ: {take_date}</div>
                                                <div className="underline">Đến: {return_date}</div>
                                            </div>
                                            <img src="/asset/icon/ico_calender.svg" alt="icon" />
                                        </>
                                            :
                                            <RangePicker
                                                className=""
                                                disabledDate={(current) => {
                                                    return current && current < moment().startOf('day');
                                                }}
                                                placeholder={["Từ", "Đến"]}
                                                id={"range_" + item.id}
                                                // defaultValue={item.take_date && item.return_date ? [dayjs(item.take_date), dayjs(item.return_date)] : null}
                                                onChange={(e: any) => {
                                                    onChangeDate(e, item, true)
                                                }}
                                                format={'DD/MM/YYYY'}
                                            />
                                        }


                                    </Column>
                                )
                            }
                            <Column className={`${!is_purchase ? 'w-1/6' : 'w-1/6'} text-center`}>
                                <div className='product_detail_right--row flex justify-center'>
                                    <InputNumber
                                        min={1}
                                        value={item.qty}
                                        onChange={(value: any) => {

                                            onChangeQty(value, item)
                                        }}
                                        //    max={parent_item?.is_bundling ? item.maximum_order : item.amount}
                                        //max={item?.bundling_id ? (item.maximum_order ?? 99999) : 99999}
                                        error={errorAmount(item)}
                                        disabled={parent_item?.allowed_split === false && !item.bundling_id ? true : parent_item?.is_product === false && !item.bundling_id ? true : false}
                                    />
                                </div>
                            </Column>
                            <Column className={`${!is_purchase ? 'w-1/6' : 'w-1/6'} text-right`}>
                                <div className="px-2 color-danger bold text-lg">
                                    {currencyFormatter.format(item.qty * price)}
                                </div>
                            </Column>

                            {
                                deleteContent(item)
                            }

                        </div>
                    )
                })
            }
        </div>
    )
}

export default TableGroup;
